import React from 'react'
import {Button, Modal, Table} from 'react-bootstrap'
import {ClientproductpriceSet} from '../../graphql/types/clientsTypes'
import {parsePrice} from '../../helpers'

interface IInfoPrices {
  id: string
  name: string
  prices: ClientproductpriceSet
}

interface IInfoPricesDelete {
  price: string
  idPrice: string
  idProduct: string
  productName: string
  idClient: string
}

interface IModalViewPriceProps {
  isOpen: boolean
  onClose: () => void
  infoPriceClient: IInfoPrices
  onOpenAddPrice: () => void
  onOpenEditPrice: () => void
  onOpenDeletePrice: () => void
  setInfoEditPrice: (obj: IInfoPricesDelete) => void
  updateInfoAddPrice: (info: {name: string; id: string; prevPrices: string[]}) => void
}

export const ModalViewPrices: React.FC<IModalViewPriceProps> = ({
  isOpen,
  onClose,
  infoPriceClient,
  onOpenAddPrice,
  updateInfoAddPrice,
  onOpenEditPrice,
  setInfoEditPrice,
  onOpenDeletePrice,
}) => {
  const {name, prices, id} = infoPriceClient
  console.log('infoPriceClient', infoPriceClient)
  return (
    <Modal show={isOpen} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          Precios para <span className='fs-2 text-uppercase text-danger'>{name}</span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {prices.edges.length > 0 ? (
          <div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>Producto</th>
                  <th>Valor exclusivo</th>
                  <th>Valor público</th>
                </tr>
              </thead>
              <tbody>
                {prices.edges.map(({node}) => (
                  <tr key={node.id}>
                    <td>{node.product.name}</td>
                    <td className='fw-bold'>
                      <div className='d-flex align-items-center justify-content-between'>
                        <span>{parsePrice(node.price)}</span>
                        <div>
                          <button
                            className='btn-reset'
                            title='Editar'
                            onClick={() => {
                              onClose()
                              onOpenEditPrice()
                              setInfoEditPrice({
                                price: node.price,
                                idPrice: node.id,
                                idProduct: node.product.id,
                                idClient: id,
                                productName: node.product.name,
                              })
                            }}
                          >
                            <i className='bi bi-pencil text-primary' />
                          </button>
                          <button
                            className='btn-reset'
                            title='Eliminar'
                            onClick={() => {
                              onClose()
                              onOpenDeletePrice()
                              setInfoEditPrice({
                                price: node.price,
                                idPrice: node.id,
                                idProduct: node.product.id,
                                idClient: id,
                                productName: node.product.name,
                              })
                            }}
                          >
                            <i className='bi bi-trash text-danger' />
                          </button>
                        </div>
                      </div>
                    </td>
                    <td style={{color: '#717171', textDecoration: 'line-through'}}>
                      {parsePrice(node.product.unitPrice)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        ) : (
          <div
            className='d-flex align-items-center justify-content-center'
            style={{height: '30vh'}}
          >
            <div className='d-flex flex-column gap-3 align-items-center justify-content-between'>
              <h4>No tiene precios exclusivos</h4>
              <Button
                variant='info'
                onClick={() => {
                  onClose()
                  updateInfoAddPrice({
                    id,
                    name,
                    prevPrices: [],
                  })
                  onOpenAddPrice()
                }}
              >
                Agregar precio
              </Button>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='dark'
          onClick={() => {
            onClose()
          }}
        >
          Aceptar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
